import * as schemas from '@gogame/schemas';

export const countryGroupsValidationSchema = schemas.object({
  id: schemas.number(),
  name: schemas.string().required('Name is required'),
  countries: schemas
    .array(
      schemas.object({
        id: schemas.number(),
        name: schemas.string(),
      })
    )
    .required('Countries is required'),
});
